@if (isBusy) {
    <ws-busy-indicator [message]="busyMessage"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Appeal Forms"
                  subHeaderLabel="Select the main form you wish to associate with this appeal."
                  acceptLabel="OK"
                  (cancel)="cancel()"
                  (save)="save()"
                  [disableSave]="!newMainFormRevisionId">

    <div class="ws-flex-container-horizontal ws-flex-align-items-center" style="margin-bottom: 10px;">
        <div class="ws-flex-none">Set appeal main form to:</div>
        <div class="ws-flex-none" style="padding-left: 8px;">
            <select class="form-select form-select-sm"
                    [(ngModel)]="newMainFormRevisionId">
                @for (item of params.mainForms; track item) {
                    <option [ngValue]="item.formRevisionId">{{ item.name }}</option>
                }
            </select>
        </div>
    </div>
    @if (!params.mainForms.length && !isBusy) {
        <span>There are no main forms available.</span>
    }

</ws-modal-wrapper>
